import axios from 'axios';
import { useConfig } from '../../config';
import { ApiCapturePaypalPayment, ApiCheckoutState, ApiCreatedOrder, ApiCreateOrderPayload } from '../../types';

export function useCreateOrder() {
	const { api } = useConfig();

	async function createOrder(payload: ApiCreateOrderPayload) {
		return axios.post<ApiCreatedOrder>(`${api}checkout/create-order2.json`, payload, { withCredentials: true });
	}

	return createOrder;
}

export function useCapturePaypalPayment() {
	const { api } = useConfig();

	async function capturePaypalPayment(id: string) {
		return axios.post<ApiCapturePaypalPayment>(
			`${api}checkout/capture-paypal-payment.json`,
			{ id },
			{
				withCredentials: true,
			}
		);
	}

	return capturePaypalPayment;
}

export function ensureShape(obj: Record<string, any>): ApiCheckoutState {
	return {
		customerType: obj.customerType ?? 'company',
		email: obj.email ?? '',
		comment: obj.comment ?? '',
		emailDone: obj.emailDone ?? false,
		discountCode: obj.discountCode ?? '',
		delivery: {
			type: obj.delivery?.type ?? 'servicepoint',
			notification: obj.delivery?.notification ?? false,
			careOf: obj.delivery?.careOf ?? '',
			firstname: obj.delivery?.firstname ?? '',
			lastname: obj.delivery?.lastname ?? '',
			phone: obj.delivery?.phone ?? '',
			city: obj.delivery?.city ?? '',
			company: obj.delivery?.company ?? '',
			doorCode: obj.delivery?.doorCode ?? '',
			street: obj.delivery?.street ?? '',
			zip: obj.delivery?.zip ?? '',
		},
		payment: {
			type: obj.payment?.type ?? 'pdf',
			einvoice: {
				identifier: obj.payment?.einvoice?.identifier ?? '',
				operator: obj.payment?.einvoice?.operator ?? '',
			},
			invoiceAddress: {
				email: obj.payment?.invoiceAddress?.email ?? '',
				orgnr: obj.payment?.invoiceAddress?.orgnr ?? '',
				company: obj.payment?.invoiceAddress?.company ?? '',
				careOf: obj.payment?.invoiceAddress?.careOf ?? '',
				street: obj.payment?.invoiceAddress?.street ?? '',
				city: obj.payment?.invoiceAddress?.city ?? '',
				zip: obj.payment?.invoiceAddress?.zip ?? '',
				ref1: obj.payment?.invoiceAddress?.ref1 ?? '',
				ref2: obj.payment?.invoiceAddress?.ref2 ?? '',
			},
		},
	};
}

export function buildCheckoutState(state: Partial<ApiCheckoutState>): ApiCheckoutState {
	return ensureShape(state);
}
